/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { computed, set } from "@ember/object";
import { trustHTML } from "@ember/template";
import { tagName } from "@ember-decorators/component";
import getUrl from "discourse/lib/get-url";
import dFormatDate from "discourse/ui-kit/helpers/d-format-date";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import I18n, { i18n } from "discourse-i18n";

@tagName("")
export default class AdminReportStorageStats extends Component {
  @computed("siteSettings.backup_location")
  get backupLocation() {
    return this.siteSettings.backup_location;
  }

  @computed("model.data.backups")
  get backupStats() {
    return this.model?.data?.backups;
  }

  set backupStats(value) {
    set(this, "model.data.backups", value);
  }

  @computed("model.data.uploads")
  get uploadStats() {
    return this.model?.data?.uploads;
  }

  set uploadStats(value) {
    set(this, "model.data.uploads", value);
  }

  @computed("backupStats")
  get showBackupStats() {
    return this.backupStats && this.currentUser.admin;
  }

  @computed("backupLocation")
  get backupLocationName() {
    return i18n(`admin.backups.location.${this.backupLocation}`);
  }

  @computed("backupStats.used_bytes")
  get usedBackupSpace() {
    return I18n.toHumanSize(this.backupStats?.used_bytes);
  }

  @computed("backupStats.free_bytes")
  get freeBackupSpace() {
    return I18n.toHumanSize(this.backupStats?.free_bytes);
  }

  @computed("uploadStats.used_bytes")
  get usedUploadSpace() {
    return I18n.toHumanSize(this.uploadStats?.used_bytes);
  }

  @computed("uploadStats.free_bytes")
  get freeUploadSpace() {
    return I18n.toHumanSize(this.uploadStats?.free_bytes);
  }

  <template>
    <div class="admin-report-storage-stats" ...attributes>
      {{#if this.showBackupStats}}
        <div class="backups">
          <h3 class="storage-stats-title">
            <a href={{getUrl "/admin/backups"}}>{{dIcon "box-archive"}}
              {{i18n "admin.dashboard.backups"}}</a>
          </h3>
          <p>
            {{#if this.backupStats.free_bytes}}
              {{i18n
                "admin.dashboard.space_used_and_free"
                usedSize=this.usedBackupSpace
                freeSize=this.freeBackupSpace
              }}
            {{else}}
              {{i18n
                "admin.dashboard.space_used"
                usedSize=this.usedBackupSpace
              }}
            {{/if}}

            <br />
            {{i18n
              "admin.dashboard.backup_count"
              count=this.backupStats.count
              location=this.backupLocationName
            }}

            {{#if this.backupStats.last_backup_taken_at}}
              <br />
              {{trustHTML
                (i18n
                  "admin.dashboard.lastest_backup"
                  date=(dFormatDate
                    this.backupStats.last_backup_taken_at leaveAgo="true"
                  )
                )
              }}
            {{/if}}
          </p>
        </div>
      {{/if}}

      <div class="uploads">
        <h3 class="storage-stats-title">{{dIcon "upload"}}
          {{i18n "admin.dashboard.uploads"}}</h3>
        <p>
          {{#if this.uploadStats.free_bytes}}
            {{i18n
              "admin.dashboard.space_used_and_free"
              usedSize=this.usedUploadSpace
              freeSize=this.freeUploadSpace
            }}
          {{else}}
            {{i18n "admin.dashboard.space_used" usedSize=this.usedUploadSpace}}
          {{/if}}
        </p>
      </div>
    </div>
  </template>
}
